import { CheckIcon, UncheckedBox } from "../../assets/designedPickedIcons";

const LabeledCheckedInput2 = ({
  label,
  value,
  setValue,
  iconColor,
  iconSize,
  Icon,
}) => {
  return (
    <div
      onClick={() => setValue(!value)}
      className={`d-flex align-items-center cursor-pointer ${
        value ? "color-primary-blue" : "color-primary-black-4"
      }  `}
      style={{ gap: 11 }}
    >
      <div style={{ color: "inherit" }}>
        {Icon ? (
          <Icon size={iconSize} checked={value} />
        ) : value ? (
          <CheckIcon size={iconSize} />
        ) : (
          <UncheckedBox size={iconSize} />
        )}
      </div>

      <p className={` m-0 f-5`}>{label}</p>
    </div>
  );
};

export default LabeledCheckedInput2;
